import { BCol, BLine, BRow } from '@prague-digi/ui-components'
import React from 'react'

import copy from '../../../../assets/pennyPayment/copy.svg'
import { copyToClipboard } from '../../../../utils/mix'
import styles from './styles.scss'

interface Props {
  description: any
  textToClipboard?: string | number
  value: any
}

export const TableRow = ({ description, textToClipboard, value }: Props) => (
  <>
    <BRow noGutters>
      <BCol>{description}</BCol>
      <BCol theme="text-right">{value}</BCol>
      {textToClipboard ? (
        <div
          className={styles.clipBoard}
          role="button"
          tabIndex={0}
          onClick={() => copyToClipboard(textToClipboard)}>
          <img alt="copy to clipboard" src={copy} />
        </div>
      ) : (
        <div className={styles.clipBoard}> </div>
      )}
    </BRow>

    <BRow noGutters theme="pr-3">
      <BCol>
        <BLine />
      </BCol>
    </BRow>
  </>
)

export default TableRow
